"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailAlertSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7,8.71760589 L7,10.0096668 L4,7.55512138 L4,13 L14,13 L14,12 L15,12 L15,13 C15,13.5522847 14.5522847,14 14,14 L4,14 C3.44771525,14 3,13.5522847 3,13 L3,6 C3,5.44771525 3.44771525,5 4,5 L7,5 L7,6 L4,6 L3.99856129,6.24832248 L7,8.71760589 Z M12.5,11 C10.0147186,11 8,8.98528137 8,6.5 C8,4.01471863 10.0147186,2 12.5,2 C14.9852814,2 17,4.01471863 17,6.5 C17,8.98528137 14.9852814,11 12.5,11 Z M12.5,10.3 C14.598682,10.3 16.3,8.59868205 16.3,6.5 C16.3,4.40131795 14.598682,2.7 12.5,2.7 C10.401318,2.7 8.7,4.40131795 8.7,6.5 C8.7,8.59868205 10.401318,10.3 12.5,10.3 Z M12,4 L13,4 L13,7 L12,7 L12,4 Z M12,8 L13,8 L13,9 L12,9 L12,8 Z" })));
};
EmailAlertSmall.displayName = 'EmailAlertSmall';
exports.default = EmailAlertSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailAlertSmall.js.map